import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/iconfont.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import api from '@/API'
import '@/assets/css/global.css'
import 'amfe-flexible'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.prototype.$api = api.module
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')
